module.exports = __webpack_public_path__ + "img/data-inherit.e2fe35c2.png";